import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "./styles/globals.css"
import "./styles/Home.module.css"
import "./styles/style.css"
// import App from './App';
import MyRouter from './config/routes';
import reportWebVitals from './reportWebVitals';
import { persistor, store } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux'
import "../src/assets/css/responsive.css"
import "../src/assets/css/style.css"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
    <MyRouter />
    </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
